import { clearPreviewPass, getPreviewPass } from '../api';

/**
 * TICK-081 — the strip that says "what you are looking at is not live".
 *
 * A preview pass makes a hidden event look exactly like a selling one, which is the point and also
 * the risk: without a marker, a screenshot from a preview session is indistinguishable from the
 * real storefront, and a tester's order looks like a customer's. So it opens every page a pass can
 * reach, and stays part of the page rather than fading like a toast.
 */
export function PreviewBanner({ eventSlug, force = false }: { eventSlug?: string; force?: boolean }) {
  const pass = getPreviewPass(eventSlug);
  /*
   * TICK-085 — `force` is for the one page a caller can now reach without holding a pass at all:
   * the order status page, opened from the link the server texts the buyer. The order itself says
   * the event is in UAT, and the strip's claim is about the event, not about the credential the
   * reader happens to be carrying — so it is shown either way. "Leave preview" only means anything
   * to someone holding a pass, so the button follows the pass and not the strip.
   */
  if (!pass && !force) return null;
  return (
    <div className="preview-banner" role="status">
      <span className="preview-banner-dot" aria-hidden="true" />
      <span>โหมดพรีวิว UAT — งานนี้ยังไม่เปิดให้คนทั่วไปเข้าถึง / Preview mode</span>
      {pass && (
        <button
          type="button"
          onClick={() => {
            clearPreviewPass(eventSlug);
            window.location.reload();
          }}
        >
          ออกจากพรีวิว
        </button>
      )}
    </div>
  );
}
